import { observer } from 'mobx-react';
import { FC } from 'react';
import { BaseCandidateFieldConfig } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

interface Props extends ExternalProps {
    rowFields: BaseCandidateFieldConfig[];
}

const Column: FC<Props> = (props) => {
    const columnStyle = `${props.baseStyle} bg-[#f5f5f5] border-t border-t-[#ddd] border-b-[3px] border-b-[#bebebe] text-[#83ab34] align-top`;
    const centerColumnStyle = `${columnStyle} text-center`;

    return (
        <thead>
            <tr className={columnStyle}>
                {props.rowFields.map((column) => (
                    <th key={column.id} className={column.id === 'pre_cumulated' ? centerColumnStyle : columnStyle}>
                        {column.name}
                    </th>
                ))}
            </tr>
        </thead>
    );
};

interface ExternalProps {
    baseStyle?: string;
}

const ColumnWithStore = (props: ExternalProps) => {
    const candidateStore = getStore().candidateStore;

    return <Column baseStyle={props.baseStyle} rowFields={candidateStore.getCandidateRowFields()} />;
};

export default observer(ColumnWithStore);
